/**
 * Local Storage Service
 * Handles storing and retrieving non-sensitive session data from local storage
 * Note: JWT tokens are stored exclusively in HttpOnly cookies to prevent XSS session hijacking.
 */

const STORAGE_KEYS = {
  USER: 'user',
  FCM_TOKEN: 'fcm_token',
  CHATBOT_ID: 'chatbotId',
} as const;

export const localStorageService = {
  // User operations
  storeUser: (user: any): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    } catch (error) {
      console.error('Error storing user:', error);
    }
  },

  getUser: (): any => {
    try {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error retrieving user:', error);
      return null;
    }
  },

  removeUser: (): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
    } catch (error) {
      console.error('Error removing user:', error);
    }
  },

  storeChatbotId: (chatbotId: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.CHATBOT_ID, chatbotId);
    } catch (error) {
      console.error('Error storing chatbot ID:', error);
    }
  },

  getChatbotId: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.CHATBOT_ID);
    } catch (error) {
      console.error('Error retrieving chatbot ID:', error);
      return null;
    }
  },

  // Clear all
  clearAll: async () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem('authToken'); // Clear legacy token if present
      localStorage.removeItem(STORAGE_KEYS.FCM_TOKEN);
      localStorage.removeItem('isRemoteAccess');
      localStorage.removeItem('remoteAccessLogId');
      localStorage.removeItem(STORAGE_KEYS.CHATBOT_ID);
      // Remove cookies
      document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      new Promise((resolve) => setTimeout(resolve, 500)); // Small delay to ensure all operations complete
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  },
};
